<template>
  <div>
    <PageAllow controller="PurchaseTasks" :action="mode ? mode : 'view'" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                mode == "complete"
                  ? $t("PurchaseTasksDetail.completeTitle")
                  : $t("CRUD.info", [$t("PurchaseTasksDetail.ObjectName")])
              }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="purchase_tasks.status | purchaseTasksStatusColor"
                :text-color="
                  purchase_tasks.status | purchaseTasksStatusTextColor
                "
              >
                {{ purchase_tasks.status | purchaseTasksStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 保存分配 -->
                <v-btn
                  v-if="
                    mode == 'complete' &&
                    $permission.permissionAllow('PurchaseTasks', 'complete')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("PurchaseTasksDetail.actions.completeSubmit") }}
                </v-btn>
              </v-sheet>
              <PurchaseTasksActions
                v-if="!isComplete"
                :purchaseTasks="purchase_tasks"
                :showComplete="purchase_tasks.status == 1"
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 采购计划单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchaseTasksDetail.Fields.purchase_task_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase_tasks.purchase_task_code }}
                </v-card>
              </v-col>
              <!-- 创建者 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchaseTasksDetail.Fields.creater")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase_tasks.creater_name }}
                  </span>
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchaseTasksDetail.Fields.created")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase_tasks.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 仓库 -->
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchaseTasksDetail.Fields.stock")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase_tasks.stock ? purchase_tasks.stock.name : "" }}
                </v-card>
              </v-col>
              <!-- 分配任务日期 -->
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchaseTasksDetail.Fields.purchase_user") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{
                    purchase_tasks.purchase_user
                      ? purchase_tasks.purchase_user.name
                      : ""
                  }}
                </v-card>
              </v-col>
              <!-- 备注 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchaseTasksDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="purchase_tasks.memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ purchase_tasks.memo }}
                  </span>
                </v-card>
              </v-col>
              <!-- 详情二维码 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchaseTasksDetail.Fields.qrcode")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-card
                    v-if="purchase_tasks.view_qrcode_url"
                    max-width="140"
                    class="elevation-0"
                  >
                    <v-img
                      :src="purchase_tasks.view_qrcode_url"
                      @click.stop="
                        $showFullscreenImages([purchase_tasks.view_qrcode_url])
                      "
                    >
                    </v-img>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isComplete">
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                v-if="$permission.permissionAllow('PurchaseTasks', 'relations')"
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("PurchasePlans.actions.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-if="$permission.permissionAllow('PurchaseTasks', 'relations')"
              >
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.identify_code="{ item }">
                      <a
                        v-if="item.identify == 'purchase_plan'"
                        :href="'/#/purchase-plans/detail/' + item.id"
                        style="text-decoration: none"
                      >
                        {{ item.identify_code }}
                      </a>
                      <a
                        v-if="item.identify == 'stock_orders_in'"
                        :href="'/#/stock-orders-in/' + item.id"
                        style="text-decoration: none"
                      >
                        {{ item.identify_code }}
                      </a>
                      <a
                        v-if="item.identify == 'purchases'"
                        :href="'/#/purchases/detail/' + item.id"
                        style="text-decoration: none"
                      >
                        {{ item.identify_code }}
                      </a>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        v-if="item.stock_order_code"
                        small
                        label
                        class="ms-1"
                        :color="item.status | stockOrderINStatusColor"
                        :text-color="item.status | stockOrderINStatusTextColor"
                      >
                        {{ item.status | stockOrderINStatusText }}
                      </v-chip>
                      <v-chip
                        v-if="item.purchase_code"
                        small
                        label
                        class="ms-1"
                        :color="item.status | purchaseStatusColor"
                        :text-color="item.status | purchaseStatusTextColor"
                      >
                        {{ item.status | purchaseStatusText }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <div class="px-4 pb-4">
      <!-- 采购计划单 -->
      <v-card class="px-4" v-if="isView">
        <!-- 采购计划单明细 -->
        <v-data-table
          :headers="detailHeaders"
          :items="purchase_task_details"
          multi-sort
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.material.material_name="{ item }">
            <span>{{ item.material.material_name }}</span>
            <br />
            <span class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
              <span v-if="item.material && item.material.standard_name && item.material.standard_name.length > 12" :title="item.material.standard_name" style="cursor: pointer">
                {{ item.material.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.material.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.supplier="{ item }">
            {{
              item.supplier
                ? item.supplier.supplier_code +
                  " / " +
                  item.supplier.supplier_name
                : ""
            }}
          </template>
        </v-data-table>
      </v-card>
      <!-- 采购计划单分配 -->
      <v-card class="px-4" v-else>
        <!-- 采购计划单 -->
        <v-data-table
          v-if="!preview"
          :headers="detailHeaders"
          :items="purchase_task_details"
          multi-sort
          disable-pagination
          hide-default-footer
        >
          <template v-slot:header.supplier="{ header }">
            {{ header.text }}
            <br />
            <v-autocomplete
              v-model="allSupplierId"
              :items="suppliers"
              item-text="Description"
              item-value="id"
              clearable
            />
          </template>
          <template v-slot:item.supplier="{ item }">
            <v-autocomplete
              v-model="item.supplier_id"
              :items="suppliers"
              item-text="Description"
              item-value="id"
              clearable
              :disabled="allSupplierId ? true : false"
            />
          </template>
          <template v-slot:item.price="{ item }">
            <v-text-field
              single-line
              dense
              hide-details
              v-model="item.price"
              type="number"
              min="0"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(
                  Number(item.price),
                  2
                )
              "
              style="max-width: 100px; margin-left: auto"
            >
            </v-text-field>
          </template>
          <!-- 采购订货数 -->
          <template v-slot:item.purchase_num="{ item }">
            <v-text-field
              single-line
              dense
              hide-details
              v-model="item.purchase_num"
              type="number"
              min="0"
              @blur="
                item.purchase_num = $numberFormatter.formatWithDotNoMoreThan(
                  Number(item.purchase_num),
                  2
                )
              "
              style="max-width: 100px; margin-left: auto"
            >
            </v-text-field>
          </template>
          <template v-slot:item.memo="{ item }">
            <v-text-field
              v-model="item.memo"
              single-line
              dense
              hide-details
              style="max-width: 200px"
            >
              <template v-slot:append>
                <v-icon
                  x-small
                  @click.stop="
                    detail_memo_item = {
                      material_code: item.material.material_code,
                      material_name: item.material.material_name,
                      memo: item.memo,
                    };
                    memoDialog = true;
                  "
                  class="pt-2 pb-1 primary--text"
                >
                  fa-edit
                </v-icon>
              </template>
            </v-text-field>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import PurchaseTasksActions from "./plugins/Actions";
import Suppliers from "@/api/suppliers";
import PurchaseTasks from "@/api/purchase_tasks.js";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    PurchaseTasksActions,
  },
  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.purchaseTasks"),
          disabled: true,
          href: "/purchase-tasks",
        },
        {
          text: i18n.t("PurchaseTasksDetail.title"),
          disabled: true,
          href: "/purchase-tasks",
        },
      ];
      return items;
    },
    isComplete() {
      return this.mode == "complete";
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return !this.preview && this.mode == "complete";
    },
    detailHeaders() {
      let headers = [
        {
          text: i18n.t("PurchaseTasksDetail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("PurchaseTasksDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("PurchaseTasksDetail.Fields.supplier"),
          align: "start",
          sortable: false,
          value: "supplier",
        },
        {
          text: i18n.t("PurchaseTasksDetail.Fields.unit"),
          align: "center",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("PurchaseTasksDetail.Fields.price"),
          align: "center",
          sortable: false,
          value: "price",
        },
        // 采购订货数
        {
          text: i18n.t("PurchaseTasksDetail.Fields.quantity"),
          align: "center",
          sortable: false,
          value: "quantity",
        },
        {
          text: i18n.t("PurchaseTasksDetail.Fields.purchase_num"),
          align: "center",
          sortable: false,
          value: "purchase_num",
        },
        {
          text: i18n.t("PurchaseTasksDetail.Fields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        },
      ];
      return headers;
    },
    relationsHeaders: () => [
      {
        text: i18n.t("PurchasePlans.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
    ],
    ...mapState(["settings", "accountUser", "accountInfo"]),
  },

  data: () => ({
    panels: [0],
    panelsDetail: [0],
    DetailTab: null,
    mode: "",
    purchase_tasks: {},
    purchase_task_details: [],
    detail_memo_item: { memo: "" },
    memoDialog: false,
    suppliers: [],
    preview: false,
    tab: null,
    relations: [],
    allSupplierId: null,
  }),

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode) {
      this.$router.replace("/purchase-tasks/detail/" + this.$route.params.id);
    }
  },

  methods: {
    getPurchaseTasksDetailsFromAPI() {
      if (this.isComplete) {
        Suppliers.fetchAllForSelect({}).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = response.data.suppliers.map((supplier) => {
                const Description =
                  supplier.supplier_code + " / " + supplier.supplier_name;
                return Object.assign({}, supplier, { Description });
              });
            }
          }.bind(this)
        );
      }
      PurchaseTasks.fetchOne(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase_tasks = response.data.purchase_task;
            this.purchase_task_details =
              response.data.purchase_task.purchase_task_details.map(
                (detail) => {
                  if (this.isComplete) {
                    detail.purchase_num =
                      this.$numberFormatter.formatWithDotNoMoreThan(
                        Number(detail.quantity),
                        2
                      );
                    detail.price = detail.last_price
                      ? this.$numberFormatter.formatWithDotNoMoreThan(
                          Number(detail.last_price),
                          2
                        )
                      : null;
                  }
                  return detail;
                }
              );
          }
        }.bind(this)
      );
      PurchaseTasks.fetchRelations(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.relations = [];
            this.relations.push(
              Object.assign(
                {
                  identify: "purchase_plan",
                  identify_name: i18n.t(
                    "PurchasePlans.RelationFields.purchase_plans"
                  ),
                  identify_code: response.data.purchase_plan.purchase_plan_code,
                },
                response.data.purchase_plan
              )
            );
            response.data.stock_orders.forEach((stock_order, index) => {
              this.relations.push(
                Object.assign(
                  {
                    index: index,
                    identify: "stock_orders_in",
                    identify_name: i18n.t("StockOrderIN.title"),
                    identify_code: stock_order.stock_order_code,
                  },
                  stock_order
                )
              );
            });
            response.data.purchases.forEach((purchase, index) => {
              this.relations.push(
                Object.assign(
                  {
                    index: index,
                    identify: "purchases",
                    identify_name: i18n.t("PurchasesList.ObjectName"),
                    identify_code: purchase.purchase_code,
                  },
                  purchase
                )
              );
            });
          }
        }.bind(this)
      );
    },
    //整理预览提交数据
    doSubmitData() {
      let PurchaseTasks = {
        id: this.purchase_tasks.id,
        memo: this.purchase_tasks.memo,
        purchase_task_details: [],
      };
      if (this.purchase_task_details) {
        this.purchase_task_details.forEach((detail) => {
          PurchaseTasks.purchase_task_details.push({
            id: detail.id,
            material_id: detail.material_id,
            supplier_id: detail.supplier_id ? detail.supplier_id : null,
            price: detail.price,
            quantity: detail.quantity,
            purchase_num: detail.purchase_num,
            memo: detail.memo,
          });
        });
      }
      return PurchaseTasks;
    },

    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      PurchaseTasks.complete(this.doSubmitData())
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/purchase-tasks");
              this.$store.dispatch("fullscreenLoadingStop");
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/purchase-tasks/detail/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getPurchaseTasksDetailsFromAPI();
        }
      },
    },
    allSupplierId: {
      handler() {
        this.purchase_task_details = this.purchase_task_details.map(
          (detail) => {
            if (this.isComplete) {
              detail.supplier_id = this.allSupplierId;
            }
            return detail;
          }
        );
      },
    },
  },
};
</script>